import cn from './cn.json';
import en from './en.json';
import jp from './jp.json';
import tw from './tw.json';

/**
 * Telecom 功能的多语言文案
 */
export const telecomLocale = {
    cn,
    en,
    jp,
    tw,
};

/**
 * 获取指定语言的文案
 * @param lang 语言代码
 */
export function getTelecomLocale(lang: 'cn' | 'en' | 'jp' | 'tw') {
    return telecomLocale[lang] || telecomLocale.en;
}
